// src/components/ButtonSet.js

import React from 'react';
import { Button } from '@chakra-ui/react';
import { ButtonSetText } from './Text';

const ButtonSet = ({ label, icon, ...props }) => {
  return (
    <Button
      {...props}
    >
      {label}
    </Button>
  );
};

export const Login = (props) => (
  <ButtonSet colorScheme="loginScheme" label={ButtonSetText.login} {...props} />
);

export const Search = (props) => (
    <ButtonSet colorScheme="searchScheme" label={ButtonSetText.search} {...props} />
  );

export const Confirm = (props) => (
  <ButtonSet colorScheme="confirmScheme" label={ButtonSetText.confirm} {...props} />
);

export const Close = (props) => (
  <ButtonSet colorScheme="closeScheme" label={ButtonSetText.close} {...props} />
);

export const Cancel = (props) => (
  <ButtonSet colorScheme="cancelScheme" label={ButtonSetText.cancel} {...props} />
);

export const Clear = (props) => (
  <ButtonSet colorScheme="clearScheme" label={ButtonSetText.clear} {...props} />
);

export const Add = (props) => (
  <ButtonSet colorScheme="addScheme" label={ButtonSetText.add} {...props} />
);

export const Edit = (props) => (
  <ButtonSet colorScheme="editScheme" label={ButtonSetText.edit} {...props} />
);

export const Delete = (props) => (
  <ButtonSet colorScheme="deleteScheme" label={ButtonSetText.delete} {...props} />
);

export const Submit = (props) => (
  <ButtonSet colorScheme="submitScheme" label={ButtonSetText.submit} {...props} />
);

export const Readmore = (props) => (
  <ButtonSet colorScheme="readmoreScheme" label={ButtonSetText.readmore} {...props} />
);

export const Back = (props) => (
  <ButtonSet colorScheme="backScheme" label={ButtonSetText.back} {...props} />
);

export const Next = (props) => (
  <ButtonSet colorScheme="nextScheme" label={ButtonSetText.next} {...props} />
);

export const Save = (props) => (
  <ButtonSet colorScheme="saveScheme" label={ButtonSetText.save} {...props} />
);

export const Download = (props) => (
  <ButtonSet colorScheme="downloadScheme" label={ButtonSetText.download} {...props} />
);

export const Upload = (props) => (
  <ButtonSet colorScheme="uploadScheme" label={ButtonSetText.upload} {...props} />
);

export const View = (props) => (
  <ButtonSet colorScheme="viewScheme" label={ButtonSetText.view} {...props} />
);

export const Print = (props) => (
  <ButtonSet colorScheme="printScheme" label={ButtonSetText.print} {...props} />
);

export const NavPrev = (props) => (
  <ButtonSet colorScheme="navScheme" label={ButtonSetText.navprev} {...props} w={10}/>
);

export const NavBegin = (props) => (
  <ButtonSet colorScheme="navScheme" label={ButtonSetText.navbegin} {...props} w={10}/>
);

export const NavNext = (props) => (
  <ButtonSet colorScheme="navScheme" label={ButtonSetText.navnext} {...props} w={10}/>
);

export const NavEnd = (props) => (
  <ButtonSet colorScheme="navScheme" label={ButtonSetText.navend} {...props} w={10}/>
);

export default ButtonSet;
